export default "__VITE_ASSET__BKvI70kq__"